import React, { Component } from 'react'
import header_2 from './images/header-2.png'
import interactive_coding from './images/interactive_coding.png'
import newton_law from './images/newton_law.png'
import value_education from './images/value_education.png'
import right_angle from './images/right_angle.png'
import process_image from './assets/Process_icon.png'
import edupreneur from './assets/edupreneur.png'
import mentor from './assets/mentor.png'
import resources from './assets/resources.png'
import resource_video from './assets/resources/resource_video.mp4'
import trig_resource_pdf from './assets/resources/right_angle_trig.pdf'
import interactive_coding_pdf from './assets/resources/interactive_coding.pdf'
import newton_first_law_motion_pdf from './assets/resources/newton_first_law_motion.pdf'
import value_education_pdf from './assets/resources/value_education.pdf'
import trig_video from './assets/resources/trig_video.mp4'
import {addData, storeBuyNowClick, storeVideoClick} from './store/actions/dataActions.js'
import { connect } from 'react-redux'

class MainComponent extends Component {
    state = {
        user_name: '',
        user_email: '',
        user_phone: '',
    }

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        })
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.addData(this.state)
        e.target.reset();
        alert('Thank you for the response! We will get in touch with you shortly.');
        console.log("Added!");
    }

    trackBuyNowClick = () => {
        this.props.storeBuyNowClick()
    }

    trackVideoClick = () => {
        this.props.storeVideoClick()
    }
    
    render() {
        return (
            <div>
                {/* Modals */}
                <div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Get in touch</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={this.handleSubmit}>
                        <div className="form-group">
                            <input id="user_name" onChange={this.handleChange} className="form-control" placeholder="Your Name*" type="text" required/>
                        </div>
                        <div className="form-group">
                            <input id="user_email" onChange={this.handleChange} className="form-control" placeholder="Your Email*" type="email" required/>
                        </div>
                        <div className="form-group">
                            <input id="user_phone" onChange={this.handleChange} className="form-control" placeholder="Your Phone(optional)" type="text" />
                        </div>
                        <input type="submit" className="btn submit-button form-control" value="SUBMIT" />
                        </form>
                    </div>
                    </div>
                </div>
                </div>

                <div className="modal fade" id="RightAngleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="RightAngleModalLabel">The Ultimate Guide to Right Angle Trigonometry</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                    <object class="PDFdoc" width="100%" height="500px" type="application/pdf" data={trig_resource_pdf}></object>
                    </div>
                    </div>
                </div>
                </div>

                <div className="modal fade" id="InteractiveCoding" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="InteractiveCodingLabel">Hands-on Guide to Interactive Coding</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                    <object class="PDFdoc" width="100%" height="500px" type="application/pdf" data={interactive_coding_pdf}></object>
                    </div>
                    </div>
                </div>
                </div>

                <div className="modal fade" id="ValueEducation" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="ValueEducationLabel">Fundamentals of Value Education for kids</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                    <object class="PDFdoc" width="100%" height="500px" type="application/pdf" data={value_education_pdf}></object>
                    </div>
                    </div>
                </div>
                </div>

                <div className="modal fade" id="NewtonLaw" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="NewtonLawLabel">Newton's First Law of Motion In Depth</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                    <object class="PDFdoc" width="100%" height="500px" type="application/pdf" data={newton_first_law_motion_pdf}></object>
                    </div>
                    </div>
                </div>
                </div>

                
                
                <section id="header">
                <h2 className="animate__animated animate__delay-1s animate__zoomIn">World’s most popular online marketplace for teacher collaboration and edupreneurship</h2>
                </section>
                <section className="container mt-5">
                <h3 className="text-center mt-4">Incredible things can happen when teachers work together.</h3>
                <div className="row mt-4">
                    <div className="col-sm-1"></div>
                    <div className="col-sm-5">
                    <img src={header_2} className="img-fluid"/>
                    </div>
                    <div className="col-sm-5">
                    <p style={{marginTop:75, fontSize:18}}>Preparing resources for conducting classes is tough. We take care of everything for you and make teaching easy and fascinating. When teachers work in coherence, it paves the way for Edupreneurship.</p>
                    </div>
                    <div className="col-sm-1"></div>
                </div>
                </section>
                <section id="flow" className="mt-5">
                <div className="row">
                    <div className="col-sm-2"></div>
                    <div className="col-sm-8 text-center">
                    <img src={process_image} className="img-fluid"/>
                    <p className="mt-5 process_content">Preparing for classes is now a problem of the past. Collaborate with amazing teachers all over the world and grow professionally. Your Edupreneurial journey starts here!</p>
                    </div>
                    <div className="col-sm-2"></div>
                </div>
                </section>
                <section id="benefits" className="mt-5 container">
                <h3 className="text-center mt-4">Benefits of working with us</h3>
                <div className="row mt-5">
                    <div className="col-sm-4 text-center">
                        <img src={edupreneur} className="img-fluid benefit-image"/>
                        <h4 className="text-center mt-4">Become an Edupreneur</h4>
                        <p>Share your treasure trove of teaching resources and generate an alternate source of income</p>
                    </div>
                    <div className="col-sm-4 text-center">
                        <img src={resources} className="img-fluid benefit-image"/>
                        <h4 className="text-center mt-4">Teacher Resources</h4>
                        <p>Save a day's effort every week by acquiring resources tailored to your unique teaching needs</p>
                    </div>
                    <div className="col-sm-4 text-center">
                        <img src={mentor} className="img-fluid benefit-image"/>
                        <h4 className="text-center mt-4">Mentorship Program</h4>
                        <p>Upskill yourself and grow professionally by seeking guidance and support from seasoned teachers</p>
                    </div>
                    </div>
                </section>
                <section id="mentor-header" className="mt-5">
                <h3>Looking for a mentor?</h3>
                <button type="button" className="btn custom-mentor-button mt-4" data-toggle="modal" data-target="#exampleModal">Get in touch</button>
                </section>
                <section id="resources" className="mt-3 container">
                <h3 className="text-center">Featured Resources</h3>
                <div className="row mt-5">
                    <div className="col-sm-4 mt-4 text-center">
                        <div className="card">
                        <img src={right_angle} className="card-img-top" alt="..." />
                        <div className="card-body">
                            <h5 className="card-title">The Ultimate Guide to Right Angle Trigonometry</h5>
                            <p className="card-text">Interactive notebook pages.<br/><br/></p>
                            <h5 className="card-title"><strike>&#x20B9; 300</strike> &#x20B9; 200<span> 15% off</span></h5>  
                            <button type="button" className="btn preview-button" data-toggle="modal" data-target="#RightAngleModal">
                            Preview
                            </button>
                            <button type="button" className="btn buy-button" onClick={this.trackBuyNowClick} data-toggle="modal" data-target="#exampleModal">
                            Buy Now
                            </button>
                        </div>
                        </div>
                    </div>
                    <div className="col-sm-4 mt-4 text-center">
                        <div className="card">
                        <img src={interactive_coding} className="card-img-top" alt="..." />
                        <div className="card-body">
                            <h5 className="card-title">Hands-on Guide to Interactive Coding</h5>
                            <p className="card-text">Ready to implement Coding exercises.<br/><br/></p>
                            <h5 className="card-title"><strike>&#x20B9; 499</strike> &#x20B9; 349<span> 30% off</span></h5>
                            <button type="button" className="btn preview-button" data-toggle="modal" data-target="#InteractiveCoding">
                            Preview
                            </button>
                            <button type="button" className="btn buy-button" onClick={this.trackBuyNowClick} data-toggle="modal" data-target="#exampleModal">
                            Buy Now
                            </button>
                        </div>
                        </div>
                    </div>
                    <div className="col-sm-4 mt-4 text-center">
                        <div className="card">
                        <img src={newton_law} className="card-img-top" alt="..." />
                        <div className="card-body">
                            <h5 className="card-title">Newton's First Law of Motion In Depth</h5>
                            <p className="card-text">15 slide Power Point on the basics of Newton's first law of motion</p>
                            <h5 className="card-title"><strike>&#x20B9; 199</strike> &#x20B9; 99<span> 50% off</span></h5>
                            <button type="button" className="btn preview-button" data-toggle="modal" data-target="#NewtonLaw">
                            Preview
                            </button>
                            <button type="button" className="btn buy-button" onClick={this.trackBuyNowClick} data-toggle="modal" data-target="#exampleModal">
                            Buy Now
                            </button>
                        </div>
                        </div>
                    </div>
                    </div>
                    <div className="row mt-5">
                    <div className="col-sm-4 mt-4 text-center">
                    <div className="card">
                        <div className="video_bg">
                        <video width="320" height="240" className="card-img-top" id="resource_video" controls onClick={this.trackVideoClick}>
                            <source src={trig_video} type="video/mp4" />
                        Your browser does not support the video tag.
                        </video>
                        </div>
                        <div className="card-body">
                            <h5 className="card-title">Teach Complex Trigonometry Problems Easily</h5>
                            <p className="card-text">Video tutorial by one of the best ICSE maths faculty of the country.</p>
                            <h5 className="card-title"><strike>&#x20B9; 599</strike> &#x20B9; 499<span> 17% off</span></h5>
                            <button type="button" className="btn buy-button" onClick={this.trackBuyNowClick} data-toggle="modal" data-target="#exampleModal">
                            Buy Now
                            </button>
                        </div>
                        </div>
                    </div>
                    {/* <div className="col-sm-4 mt-4 text-center">
                        <div className="card">
                        <img src={explore_world} className="card-img-top" alt="..." />
                        <div className="card-body">
                            <h5 className="card-title">Explore your Dream Travel Destination</h5>
                            <p className="card-text">A short description here which tells us the topics in brief.</p>
                            <h5 className="card-title"><strike>INR 499</strike> INR 349<span> 30% off</span></h5>
                            <a href="#" className="btn preview-button">Preview</a>
                            <a href="#" className="btn buy-button">Buy Now</a>
                        </div>
                        </div>
                    </div> */}
                    <div className="col-sm-4 mt-4 text-center">
                        <div className="card">
                        <img src={value_education} className="card-img-top" alt="..." />
                        <div className="card-body">
                            <h5 className="card-title">Fundamentals of Value Education for kids</h5>
                            <p className="card-text">Interactive assignment on Hindu mythology.</p>
                            <h5 className="card-title">FREE</h5>
                            <button type="button" className="btn preview-button" onClick={this.trackBuyNowClick} data-toggle="modal" data-target="#ValueEducation">
                            Preview
                            </button>
                            <button type="button" className="btn buy-button" onClick={this.trackBuyNowClick} data-toggle="modal" data-target="#exampleModal">
                            Download
                            </button> 
                        </div>
                        </div>
                    </div>
                    <div className="col-sm-4 mt-4 text-center">
                    <div className="card">
                        <div className="video_bg">
                            <video width="320" height="240" className="card-img-top" id="resource_video" controls onClick={this.trackVideoClick}>
                                <source src={resource_video} type="video/mp4" />
                            Your browser does not support the video tag.
                            </video>
                            </div>
                        <div className="card-body">
                            <h5 className="card-title">Launch your Online Teaching Career</h5>
                            <p className="card-text">Useful tips for conducting classes on Zoom, Google Meet and Google Classroom.</p>
                            <h5 className="card-title">FREE</h5>
                            {/* <button type="button" className="btn buy-button" data-toggle="modal" data-target="#exampleModal">
                            Buy Now
                            </button> */}
                        </div>
                        </div>
                    </div>
                    
                    </div>

                </section>
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addData: (data) => {dispatch(addData(data))},
        storeBuyNowClick : () => {dispatch(storeBuyNowClick())},
        storeVideoClick : () => {dispatch(storeVideoClick())}
    }
}
  
export default connect(null, mapDispatchToProps)(MainComponent)
